import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import logoMark from '../assets/logo-mark.png';

export function TopBar({ title, back, logo }: { title: string; back?: boolean; logo?: boolean }) {
  const navigate = useNavigate();
  return (
    <div className="topbar">
      {back ? (
        <button
          type="button"
          className="topbar-back"
          onClick={() => navigate(-1)}
          aria-label="Retour"
          style={{ cursor: 'pointer' }}
        >
          <ArrowLeft size={18} strokeWidth={2.4} />
        </button>
      ) : logo ? (
        <img src={logoMark} alt="" width={28} height={28} />
      ) : (
        <div style={{ width: 36 }} />
      )}
      <span className="topbar-title">{title}</span>
      <div style={{ width: 36 }} />
    </div>
  );
}
